var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen"},[_c('span',[_vm._v("我的位置："+_vm._s(_vm.currentPosition.address))]),_c('img',{attrs:{"src":require("@/assets/public/map_point.png")},on:{"click":_vm.clickCurrentPoint}}),_c('el-button',{staticClass:"btn",on:{"click":_vm.fullScreen}},[_vm._v("退出全屏")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }